
import { Species } from "../../api/dtos/dtos";

export const DefaultSpeciesThemes = {
    [Species.WildDog]: {
        primaryColor: '#ff6600',
        secondaryColor: '#AC3F30',
        contrastColor: '#673628',
        backgroundColor: '#753d2e',
        
        hasManagement: true,
        hasGroupsTotal: true,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Deer]: {
        primaryColor: '#CF8A6B',
        secondaryColor: '#947B67',
        contrastColor: '#5a4431',
        backgroundColor: '#5a4431',
        
        hasManagement: true,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Rabbit]: {
        primaryColor: '#69AA32',
        secondaryColor: '#DE4E00',
        contrastColor: '#5F2B10',
        backgroundColor: '#5F2B10',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.FeralCat]: {
        primaryColor: '#EBA50F',
        secondaryColor: '#936D29',
        contrastColor: '#5C3B02',
        backgroundColor: '#5C3B02',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Fox]: {
        primaryColor: '#DF5E36',
        secondaryColor: '#E0804C',
        contrastColor: '#682510',
        backgroundColor: '#682510',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.FeralPig]: {
        primaryColor: '#8F6960',
        secondaryColor: '#807F24',
        contrastColor: '#403633',
        backgroundColor: '#403633',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Myna]: {
        primaryColor: '#EFB929',
        secondaryColor: '#995A32',
        contrastColor: '#352106',
        backgroundColor: '#352106',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Toad]: {
        primaryColor: '#CA7018',
        secondaryColor: '#978133',
        contrastColor: '#3E3204',
        backgroundColor: '#3E3204',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Mouse]: {
        primaryColor: '#773A5C',
        secondaryColor: '#8A7A66',
        contrastColor: '#938878',
        backgroundColor: '#938878',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.FeralGoat]: {
        primaryColor: '#A88E5B',
        secondaryColor: '#D3A345',
        contrastColor: '#6f5e45',
        backgroundColor: '#6f5e45',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.FeralFish]: {
        primaryColor: '#9E956A',
        secondaryColor: '#35739D',
        contrastColor: '#264760',
        backgroundColor: '#264760',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.Starling]: {
        primaryColor: '#3E7669',
        secondaryColor: '#927D76',
        contrastColor: '#46342a',
        backgroundColor: '#46342a',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.OtherPests]: {
        primaryColor: '#ff6600',
        secondaryColor: '#AC3F30',
        contrastColor: '#673628',
        backgroundColor: '#673628',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: true,
        hasRecentRecords: true,
    },
    [Species.NewPests]: {
        primaryColor: '#ED772F',
        secondaryColor: '#499998',
        contrastColor: '#394E4B',
        backgroundColor: '#394E4B',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: false,
        hasRecentRecords: false,
    },
    [Species.None]: {
        primaryColor: '#ff6600',
        secondaryColor: '#AC3F30',
        contrastColor: '#673628',
        backgroundColor: '#673628',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: false,
        hasRecentRecords: false,
    },
    
    // Ignore this style... I've added this to make
    // TS happy
    [Species.Camel]: {
        primaryColor: '#ff6600',
        secondaryColor: '#AC3F30',
        contrastColor: '#673628',
        backgroundColor: '#673628',
        
        hasManagement: false,
        hasGroupsTotal: false,
        hasTotalRecords: false,
        hasRecentRecords: false,
    },
}